import React from 'react';
import Header from "./components/Header/Header";
import Cards from "./components/Cards/Cards";
import Footer from "./components/Footer/Footer";

function App() {
  return (
    <>
      <Header />
      <Cards />
      <Footer />
    </>
  );
}

export default App;
